<script>
    let menuVisible = false;
    let opener;
</script>
<style>
    .gac-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3rem;
        background-color: white;
        padding: 0.5rem;
        font-size: 1.25rem;
        z-index: 10;
    }
    img {
        height: 100%;
        vertical-align: middle;
    }
    a {
        text-decoration: none;
        color: #777;
        line-height: 1.25rem;
    }
    .menu {
        position: absolute;
        bottom: 3rem;
        background-color: white;
        font-size: 1rem;
        font-family: Roboto, sans-serif;
        border-radius: 0.25rem;
        padding: 1rem;
        margin: 0 0 0.25rem -0.25rem;
    }
    .kebab {
        border: none;
        background: transparent;
        margin: 0;
        padding: 0 0.5rem 0 0.5rem;
        cursor: pointer;
    }
</style>

<div style="height: 3rem;">&nbsp;</div>

<svelte:body on:click={(e) => {if (e.target != opener) menuVisible = false;}} />

<footer class="gac-footer">
    {#if menuVisible}
    <div class="menu">
        <a href="https://policies.google.com/" title="Privacy policy" target="_blank">Privacy policy</a>
    </div>
    {/if}
    <button class="kebab"
        bind:this={opener}
        on:click={() => {menuVisible = !menuVisible;}}
        title="Open menu">⋮</button><a href="https://artsandculture.google.com/" target="_blank">
        <img src="assets/images/gac-logo-dark.png" alt="Google Arts and Culture">
    </a>
</footer>